(function () {
  'use strict';

  let lastQuickAddTrigger = null;

  function getFocusableElements(container) {
    return container.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
  }

  function focusQuickAddModal(modal) {
    const focusableElements = getFocusableElements(modal);
    const firstElement = focusableElements[0];

    if (firstElement) {
      firstElement.focus();
    }
  }

  function trapQuickAddFocus(modal, event) {
    if (event.key !== 'Tab') return;

    const focusableElements = getFocusableElements(modal);
    if (!focusableElements.length) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (!modal.contains(document.activeElement)) {
      event.preventDefault();
      firstElement.focus();
      return;
    }

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
      return;
    }

    if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  }

  function closeQuickAddModal(modal, restoreFocus = true) {
    if (!modal) return;

    modal.setAttribute('hidden', '');
    document.body.classList.remove('quick-add-open');

    if (restoreFocus) {
      lastQuickAddTrigger?.focus();
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.quick-add-modal').forEach(function (modal) {
      document.body.appendChild(modal);
    });
  });

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-product-id]');
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    const modal = document.getElementById('quick-add-' + trigger.dataset.productId);
    if (!modal) return;

    lastQuickAddTrigger = trigger;

    modal.removeAttribute('hidden');
    document.body.classList.add('quick-add-open');

    window.requestAnimationFrame(function () {
      focusQuickAddModal(modal);
    });
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-modal-close]')) return;

    event.preventDefault();
    event.stopPropagation();

    const modal = event.target.closest('.quick-add-modal');
    closeQuickAddModal(modal);
  });

  document.addEventListener('keydown', function (event) {
    const openModal = document.querySelector('.quick-add-modal:not([hidden])');
    if (!openModal) return;

    if (event.key === 'Escape') {
      closeQuickAddModal(openModal);
      return;
    }

    trapQuickAddFocus(openModal, event);
  });

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.quick-add-atc-btn');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const variantId = button.dataset.variantId;
    const originalText = button.textContent;

    button.disabled = true;
    button.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (response) {
        if (!response.ok) throw new Error();
        return response.json();
      })
      .then(function () {
        button.textContent = 'Added!';

        return typeof addToCartAndUpdate === 'function'
          ? addToCartAndUpdate()
          : fetch('/cart.js')
              .then(function (response) { return response.json(); })
              .then(function (cart) {
                document.querySelectorAll('[data-cart-count]').forEach(function (element) {
                  element.textContent = cart.item_count;
                });
              });
      })
      .then(function () {
        setTimeout(function () {
          const modal = button.closest('.quick-add-modal');

          closeQuickAddModal(modal, false);

          button.disabled = false;
          button.textContent = originalText;

          lastQuickAddTrigger?.focus();

          if (typeof openSlideCart === 'function') {
            openSlideCart();
          }
        }, 500);
      })
      .catch(function () {
        button.textContent = 'Error - try again';
        button.disabled = false;

        setTimeout(function () {
          button.textContent = originalText;
        }, 2000);
      });
  });

})();